module.exports = __webpack_public_path__ + "img/QQ.fe8fb32c.png";